import {  Col, Container } from 'react-bootstrap';

function Main ({children}) {
    return (
        <Col lg={9} md={12}>
            <Container className='man-main-wrapper'>{children}</Container>
        </Col>
    )
};

export default Main;